import { getDifficultySettings } from '../config/difficultySettings';

export class ScoreManager {
  private score: number = 0;
  private highScore: number = 0;
  private multiplier: number = 1;
  private onScoreChange?: (score: number) => void;

  constructor() {
    // Load high score from localStorage if available
    const savedHighScore = localStorage.getItem('rollerToaster_highScore');
    if (savedHighScore) {
      this.highScore = parseInt(savedHighScore, 10);
    }
    
    // Apply difficulty multiplier
    const settings = getDifficultySettings();
    this.multiplier = settings.scoreMultiplier;
  }

  addPoints(points: number): void {
    this.score += Math.floor(points * this.multiplier);
    this.onScoreChange?.(this.score);
    
    // Update high score if needed
    if (this.score > this.highScore) {
      this.highScore = this.score;
      localStorage.setItem('rollerToaster_highScore', this.highScore.toString());
    }
  }

  addWaveBonus(waveNumber: number): void {
    const bonus = 500 * waveNumber;
    this.addPoints(bonus);
  }

  addNoDamageBonus(): void {
    this.addPoints(200);
  }

  getScore(): number {
    return this.score;
  }

  getHighScore(): number {
    return this.highScore;
  }

  setMultiplier(multiplier: number): void {
    this.multiplier = multiplier;
  }

  setOnScoreChange(callback: (score: number) => void): void {
    this.onScoreChange = callback;
  }

  reset(): void {
    this.score = 0;
    this.multiplier = 1;
    this.onScoreChange?.(this.score);
  }
}


